// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"6c3d4a0d","198":"cf60d99d"}[chunkId] + ".chunk.js";
};